import { DocumentReference , setDoc, Timestamp } from "firebase/firestore";

export type DraftFieldType = {
  value?: string;
  isLocked?: boolean;
  lockedByUserId: string;
  lockedByUserName: string;
  lastTouchedAt: Timestamp;
};

export const updateDraftField = async (
  reference: DocumentReference,
  data: Partial<DraftFieldType>,
): Promise<void> => {
  return setDoc(reference, data, {
    merge: true,
  });
};
